import { useEffect } from 'react';
import { useAppConfigContext } from '@vivli/core/infrastructure/context';
import { useAppEnvironment } from './use-app-environment.hook';

export const useEnvironmentTitle = () => {
    const config = useAppConfigContext();
    const { activeEnv: currentEnv } = useAppEnvironment();

    useEffect(() => {
        const isVivliOrg = window.location.host.toLowerCase().includes('vivli.org');

        if (!isVivliOrg) {
            const activeEnv = config.queryUri.split('-')[1];
            const isLocal = currentEnv === 'local';

            document.title = `Vivli - ${isLocal ? 'LOCAL ' : ''}${activeEnv?.toUpperCase()}`;
        }
    }, [config.queryUri, currentEnv]);
};
